<template>
    <div id="conversation-list">
        <div class="search">
            <a-input
                :placeholder="$t('message.search')"
                class="search-item"
                v-model="searchValue"
                name="search"
                autocomplete="off"
            ></a-input>
        </div>
        <NoMessage v-if="!filterDatas.length" :desc="$t('message.noMessage')" />
        <div
            class="chat-item"
            :class="{
                selected: $_.get(selectedChat, '_id') === data._id,
                [data.meta.chatType]: true,
            }"
            v-for="data in filterDatas"
        >
            <div class="chat-card" @click="openConv(data)">
                <div class="second">
                    <div class="chat-avatar">
                        <Avatar
                            class="AvatarOnChat"
                            :size="30"
                            :username="getName(data.meta) || ''"
                            :src="getAgentImage(data)"
                        />
                    </div>
                    <div class="chat-content">
                        <span class="chat-content-span">
                            <div class="tooltip-container" :title="getName(data.meta)">
                                {{ getName(data.meta) }}
                            </div>

                            <div class="typing-message" v-if="typingMessageVisible(data)">
                                {{ typingMessage(data) + " " + $t("message.typing_w_chat") }}
                            </div>
                            <div v-else>
                                <div class="message">
                                    {{ messageText(getLastMessage(data)) }}
                                </div>
                            </div>
                        </span>
                    </div>
                    <div class="toolbarC">
                        <div class="toolbar">
                            <div class="right">
                                <div>
                                    <span class="material-icons notification-volume" v-if="!isMute(data)"
                                        >volume_off</span
                                    >
                                </div>
                                <!--                       <div class="date">{{ messageDate(getLastMessage(data)) }}</div>-->
                                <div>
                                    <span
                                        class="material-icons pinButton"
                                        v-if="
                                            data.meta.chatType === 'team' ||
                                            (data.meta.chatType == 'thread' &&
                                                data.meta.thread.agent1._id == data.meta.thread.agent2._id)
                                        "
                                        >push_pin
                                    </span>
                                </div>
                                <div>
                                    <a-popover
                                        id="chat-detail"
                                        class=""
                                        placement="right"
                                        trigger="click"
                                        v-if="infoVisibility"
                                    >
                                        <span class="material-icons btnMore" @click="selectedMoreChat = data">
                                            more_horiz</span
                                        >
                                        <div slot="content">
                                            <button
                                                @click="moreChatVisible = true"
                                                class="chat-detail-item"
                                                v-if="nameUpdateCondition(data)"
                                            >
                                                {{ $t("message.edit_group_info") }}
                                            </button>
                                            <button
                                                class="chat-detail-item"
                                                @click="notificationOpen(data)"
                                                v-if="!isMute(data)"
                                            >
                                                {{ $t("message.notif_sound") }}
                                            </button>
                                            <button class="chat-detail-item" @click="notificationClose(data)" v-else>
                                                {{ $t("message.notif_mute") }}
                                            </button>
                                            <button
                                                @click="leaveGroup"
                                                class="chat-detail-item"
                                                v-if="leaveChatCondition(data)"
                                            >
                                                {{ $t("message.leave") }}
                                            </button>
                                            <button
                                                class="chat-detail-item"
                                                @click="deleteModal = true"
                                                v-if="deleteChat(data)"
                                            >
                                                {{ $t("chatbotv2.delete") }}
                                            </button>
                                        </div>
                                    </a-popover>
                                </div>
                            </div>
                        </div>
                        <span class="unread-count" v-if="getUnreadMessageCount(data) > 0">{{
                            getUnreadMessageCount(data)
                        }}</span>
                        <div class="left">
                            <div class="type-tag" v-if="isTeam(data)">
                                <div class="type-tagTwo">
                                    <span class="span-hour"> {{ messageDate(getLastMessage(data)) }}</span>
                                </div>
                                <div class="type-tagTwo">
                                    <span class="span-typeS team">{{ $t("message.team") }}</span>
                                </div>
                            </div>
                            <div class="type-tag" v-else-if="isGroup(data)">
                                <div class="type-tagTwo">
                                    <span class="span-hour"> {{ messageDate(getLastMessage(data)) }}</span>
                                </div>
                                <div class="type-tagTwo">
                                    <span class="span-typeS group"> {{ $t("message.group") }}</span>
                                </div>
                            </div>
                            <div class="type-tag" v-else-if="isDepartment(data)">
                                <div class="type-tagTwo">
                                    <span class="span-hour"> {{ messageDate(getLastMessage(data)) }}</span>
                                </div>
                                <div class="type-tagTwo">
                                    <span class="span-typeS department"> {{ $t("message.department") }}</span>
                                </div>
                            </div>
                            <div class="type-tag" v-else-if="isThreadPrivate(data)">
                                <div class="type-tagTwo">
                                    <span class="span-hour">{{ messageDate(getLastMessage(data)) }}</span>
                                </div>
                                <div class="type-tagTwo">
                                    <span class="span-typeS note"> {{ $t("userInfoWidget.note") }} </span>
                                </div>
                            </div>
                            <div class="type-tag" v-else-if="isThread(data)">
                                <div class="type-tagTwo">
                                    <span class="span-hour">{{ messageDate(getLastMessage(data)) }}</span>
                                </div>
                                <div class="type-tagTwo"><span class="span-typeS thread">DM</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal2
            v-if="moreChatVisible"
            :title="$t('message.set_group_info')"
            :description="getName(selectedMoreChat.meta)"
            id="update-chat-info"
            :show-footer="false"
            @cancel="moreChatVisible = false"
        >
            <label>{{ $t("message.new_name") }}</label>
            <input id="update-chat-name" v-model="newChatName" type="text" />
            <div>
                <a-button class="" @click="GroupNameChange"> {{ $t("message.save") }}</a-button>
            </div>
        </Modal2>
        <a-modal v-model="deleteModal" icon="exclamation-circle" title="Delete Chat" @cancel="deleteModal = false">
            <p>{{ $t("message.delChannel") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteGroupThreadConversation">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import moment from "moment";
import Modal2 from "../../../components/common/Modal2";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import StringUtils from "../../../utils/StringUtils";
import Avatar from "vue-avatar";
import NoMessage from "./NoMessage";
import { filter, map } from "rxjs/operators";
import { deleteGrup } from "../../../api/team";

const log = log2("ChatList");

export default {
    name: "ChatList",
    components: { Modal2, Avatar, NoMessage },
    props: {
        selectedChatType: {
            type: String,
            default: "all",
        },
    },
    data() {
        return {
            users: [],
            selected: "all",
            filterDatas: [],
            datas: [],
            clicked: false,
            chatUpdate: false,
            moreChatVisible: false,
            infoVisibility: true,
            lastMessage: "",
            newChatName: "",
            selectedMoreChat: null,
            searchValue: "",
            StringUtils,
            deleteModal: false,
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            site: (state) => state.site.site,
            selectedChat: (state) => state.team.selectedChat,
            user: (state) => state.auth.user,
            chats: (state) => state.team.chats,
            unreadCountMessage: (state) => state.team.unreadMessages,
            lastMessages: (state) => state.team.lastMessages,
            notificationSettings: (state) => state.team.notificationSettings,
            typingMessagesState: (state) => state.team.typingMessages,
        }),
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            chatNameUpdate: "team/chatNameUpdate",
            chatProfilePhotoUpdate: "team/chatProfilePhotoUpdate",
            leaveChatGroup: "team/leaveChatGroup",
            selectedChatChange: "team/selectedChatChange",
            notificationSetting: "team/notificationSetting",
            typingMessages: "team/typingMessages",
            deleteGrup: "team/deleteGrup",
        }),
        typingMessage(data) {
            return this.typingMessagesState.find((item) => item.chatId === data._id)?.userName;
        },
        typingMessageVisible(data) {
            const result = this.typingMessagesState.filter((item) => item.chatId === data._id);
            const anyMessageNotEmpty = result.some((item) => item.message !== "");
            return result.length > 0 && anyMessageNotEmpty;
        },
        isMute(data) {
            const result = this.notificationSettings.filter((item) => item.chatId === data._id);
            if (result.length > 0) {
                return result[0].mute;
            } else {
                return true;
            }
        },
        notificationOpen(data) {
            this.notificationSetting({ chatId: data._id, mute: true });
        },
        notificationClose(data) {
            this.notificationSetting({ chatId: data._id, mute: false });
        },
        isTeam(chat) {
            return chat.meta.chatType === "team";
        },
        isDepartment(chat) {
            return chat.meta.chatType === "department";
        },
        isGroup(chat) {
            return chat.meta.chatType === "groupThread";
        },
        isThread(chat) {
            return chat.meta.chatType === "thread";
        },
        isThreadPrivate(chat) {
            return chat.meta.chatType === "thread" && chat.meta.thread.agent1._id === chat.meta.thread.agent2._id;
        },
        async leaveGroup() {
            this.infoVisibility = false;
            await this.leaveChatGroup({ chat: this.selectedMoreChat, userId: this.user._id });
            sendSocketMessage("team leave-group", {
                siteId: this.site._id,
                conversationId: this.selectedMoreChat._id,
            });
            sendSocketMessage("team refresh-chats", {
                siteId: this.site._id,
            });
            this.selectedMoreChat = null;
            this.infoVisibility = true;
        },
        async GroupNameChange() {
            await this.chatNameUpdate({
                chatId: this.selectedMoreChat._id,
                name: this.newChatName,
            });
            sendSocketMessage("team refresh-chats", {
                siteId: this.site._id,
            });
            this.moreChatVisible = false;
        },
        nameUpdateCondition(data) {
            return data.meta.chatType === "groupThread" && data.meta.groupThread.creator._id === this.user._id;
        },
        leaveChatCondition(data) {
            return data.meta.chatType === "groupThread" && data.meta.groupThread.creator._id !== this.user._id;
        },
        deleteChat(data) {
            return data.meta.chatType === "groupThread" && data.meta.groupThread.creator._id === this.user._id;
        },
        getName(data) {
            if (data.chatType === "groupThread") {
                return data.groupThread.title;
            } else if (data.chatType === "thread") {
                if (data.thread.agent2._id === data.thread.agent1._id) {
                    return " Me 📝 ";
                } else if (data.thread.agent2._id === this.user._id) {
                    return data.thread.agent1.name;
                }
                return data.thread.agent2.name;
            } else if (data.chatType === "department") {
                return data.department.languageContent[0].name;
            } else {
                return data.chatType.toUpperCase();
            }
        },
        async openConv(data) {
            await this.selectedChatChange(data);
        },
        getDatasByType(newValue) {
            switch (newValue) {
                case "all":
                    this.filterDatas = this.chats;
                    break;
                case "departments":
                    this.filterDatas = this.chats.filter((chat) => chat.meta.chatType === "department");
                    break;
                case "groups":
                    this.filterDatas = this.chats.filter((chat) => chat.meta.chatType === "groupThread");
                    break;
            }
        },
        getLastMessage(data) {
            return this.lastMessages.filter((item) => {
                if (item !== null) {
                    if (item.conversation.toString() === data._id.toString()) {
                        return item;
                    }
                }
                return null;
            });
        },
        messageText(msg) {
            if (msg.length === 0) return "";
            if (msg[0].messageType === "user-media") {
                return "dosya";
            } else {
                let lastMessage = msg[0].description ? msg[0].description : "";
                lastMessage = StringUtils.clearHTML(lastMessage);
                return lastMessage;
            }
        },
        messageDate(msg) {
            if (msg.length === 0) return "";
            const lastMessageDate = msg[0].createdDate ? msg[0].createdDate : "";
            if (lastMessageDate === "") return "";
            const lastMessageDateFormat = moment(lastMessageDate).format("dddd");
            if (moment().format("dddd") === lastMessageDateFormat) {
                return moment(lastMessageDate).format("LT");
            } else {
                return lastMessageDateFormat;
            }
        },
        getUnreadMessageCount(data) {
            const indexUnreadMessage = this.unreadCountMessage.findIndex((item) => item.chatId === data._id);
            if (indexUnreadMessage !== -1) return this.unreadCountMessage[indexUnreadMessage].unreadCount;
            return 0;
        },
        getAgentImage(chat) {
            if (chat.meta.chatType === "groupThread") {
                return chat.meta.groupThread?.groupProfilePicture;
            } else if (chat.meta.chatType === "thread") {
                if (chat.meta.thread.agent2._id.toString() === this.user._id.toString()) {
                    return chat.meta.thread.agent1.gravatar;
                }
                return chat.meta.thread.agent2.gravatar;
            } else if (chat.meta.chatType === "team") {
                return chat.meta.groupThread?.groupProfilePicture;
            } else if (chat.meta.chatType === "department") {
                return chat.meta.groupThread?.groupProfilePicture;
            }
        },
        async deleteGroupThreadConversation() {
            await this.deleteGrup({ chatId: this.selectedMoreChat._id });
            sendSocketMessage("team list-chats", {
                siteId: this.site._id,
                userId: this.user._id,
            });
            this.deleteModal = false;
        },
    },
    async mounted() {
        moment.locale("tr");
        this.filterDatas = this.chats;

        this.messageSubscriber = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "team_typing_message"),
                map((x) => x.data)
            )
            .subscribe(async (data) => {
                this.typingMessages(data);
            });
    },
    beforeDestroy() {
        if (!!this.messageSubscriber) {
            this.messageSubscriber.unsubscribe();
        }
    },
    watch: {
        selectedChatType(newValue) {
            this.getDatasByType(newValue);
            this.searchValue = "";
        },
        chats: {
            handler(newValue) {
                this.getDatasByType(this.selectedChatType);
            },
            deep: true,
        },
        searchValue(newVal) {
            this.filterDatas = this.chats.filter((chat) => {
                if (chat.meta.chatType === "groupThread") {
                    return chat.meta.groupThread.title.toLowerCase().includes(newVal.toLowerCase());
                } else if (chat.meta.chatType === "thread") {
                    if (chat.meta.thread.agent2._id === this.user._id) {
                        return chat.meta.thread.agent1.name.toLowerCase().includes(newVal.toLowerCase());
                    }
                    return chat.meta.thread.agent2.name.toLowerCase().includes(newVal.toLowerCase());
                } else if (chat.meta.chatType === "department") {
                    return chat.meta.department.languageContent[0].name.toLowerCase().includes(newVal.toLowerCase());
                } else {
                    return chat.meta.chatType.toLowerCase().includes(newVal.toLowerCase());
                }
            });
        },
    },
};
</script>

<style lang="scss">
.chat-detail-item {
    border: none;
    display: flex;
    background: none;
    padding: 5px;
    border-radius: 5px;
    color: black;

    &:hover {
        background-color: #a8adb6;
    }
}

#conversation-list {
    max-height: calc(100vh - 150px) !important;
    overflow: auto;
    font-size: 14px;
    font-weight: 400;
    color: var(--color-text-default);

    &::-webkit-scrollbar {
        display: none !important;
    }

    .search {
        margin: 5px;

        .search-item {
            border-radius: 10px;
        }
    }

    .chat-item {
        border-bottom: 1px solid #f2f2f2;
        border-left: 3px solid transparent;

        &.selected {
            &.team {
                border-left: 3px solid #ec4a1d;
                background: #ec4a1d1a;
            }

            &.groupThread {
                border-left: 3px solid #009688;
                background: #0096881a;
            }

            &.department {
                border-left: 3px solid #9c27b0;
                background: #9c27b01a;
            }

            &.thread {
                border-left: 3px solid #03a9f3;
                background: #03a9f31a;
            }

            &.note {
                border-left: 3px solid #5db622;
                background: #5db6221a;
            }
        }

        .conv-active {
            background-color: #ec4a1d;
            width: 4px;
        }

        .chat-card {
            padding: 10px;
            width: 100%;
            cursor: pointer;
            position: relative;
            height: 69px;

            .toolbarC {
                display: grid;
                width: 35%;
            }

            .toolbar {
                width: 100%;

                .right {
                    display: flex;
                    align-items: center;
                    justify-content: end;
                    gap: 3px;
                    height: 25px;
                }

                .date {
                    font-size: 12px;
                    color: #a8adb6;
                }

                .material-icons {
                    width: 15px;
                    height: 15px;
                }

                .notification-volume {
                    font-size: 18px;
                }

                .pinButton {
                    color: #a8adb6;
                    font-size: 18px;
                    cursor: pointer;
                }

                .btnMore {
                    color: #a8adb6;
                    cursor: pointer;
                }
            }

            .second {
                display: flex;
                align-items: center;
                column-gap: 5px;

                .chat-avatar {
                    width: 15%;
                }

                .tooltip-container {
                    width: 110px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .chat-content {
                    width: 50%;

                    .chat-content-span {
                        display: inline-block;
                    }

                    .name {
                        font-weight: 700;
                        font-size: 15px;
                    }

                    .message {
                        width: 110px;
                        font-size: 14px;
                        color: #a8adb6;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .typing-message {
                        width: 110px;
                        font-size: 14px;
                        color: #40ad36;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        .typing-message-long {
                            width: 51px;
                            white-space: nowrap;
                            overflow: hidden;
                        }
                    }
                }
            }

            .second {
                .left {
                    .type-tag {
                        display: grid;
                        gap: 1px;
                        font-size: 9px;
                        opacity: 0.7;
                    }

                    .type-tagTwo {
                        text-align: end;
                    }

                    .span-hour {
                        font-size: 9px;
                    }

                    .span-typeS {
                        font-size: 9px;
                        border: 1px solid #a8adb6;
                        border-radius: 4px;
                        padding: 1px 3px;
                        opacity: 0.7;

                        &.team {
                            border-color: #ec4a1d;
                            background: #ec4a1d;
                            color: white;
                        }

                        &.department {
                            border-color: rgb(156, 39, 176);
                            background: rgb(156, 39, 176);
                            color: white;
                        }

                        &.group {
                            border-color: rgb(0, 150, 136);
                            background: rgb(0, 150, 136);
                            color: white;
                        }

                        &.thread {
                            border-color: #03a9f3;
                            background: #03a9f3;
                            color: white;
                        }

                        &.note {
                            border-color: #5db622;
                            background: #5db622;
                            color: white;
                        }
                    }
                }
            }

            .unread-count {
                border-radius: 50%;
                background-color: #46c053;
                color: white;
                height: 17px;
                width: 17px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: x-small;
                position: absolute;
                right: 20%;
                font-weight: 900;
            }

            .conv-time {
                color: #c4c4c4;
            }
        }

        .chat-detail-popup {
            border: none;
            background: none;
            box-shadow: none;
        }
    }

    .AvatarOnChat {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        line-height: 31px;
        font-weight: bold;
        align-items: center;
        justify-content: center;
        text-align: center;
        user-select: none;
        color: white;
        font-size: 15px;
        background-size: cover !important;
    }
}
</style>
